exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.permutation-preview[data-v-e805d3de] {\n  max-height: calc(100vh - 450px);\n  overflow-y: auto;\n}\n", ""]);

// exports
